import { createFileRoute } from "@tanstack/react-router";
import { PatentAiChat } from "@/components/site/PatentAiChat";
import { SiteFooter } from "@/components/site/SiteFooter";
import { SiteHeader } from "@/components/site/SiteHeader";

export const Route = createFileRoute("/patent-ai")({
  head: () => ({
    meta: [
       { title: "Ask AI: European Patent & EU Trade Mark Fees" },
      {
        name: "description",
         content: "Ask about European patent, EPO and EU trade mark procedures, drafting, office actions, oppositions, renewals and indicative official and attorney fees.",
      },
       { property: "og:title", content: "Ask AI: European Patent & EU Trade Mark Fees" },
       { property: "og:image", content: "https://bauerip.com/og-us.jpg" },
       { name: "twitter:image", content: "https://bauerip.com/og-us.jpg" },
      {
        property: "og:description",
         content: "A preliminary European patent and EU trade mark procedure and fee guide for US companies, backed by Bauer IP's indicative schedules.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://bauerip.com/patent-ai" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://bauerip.com/patent-ai" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          name: "Bauer IP Ask AI",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          url: "https://bauerip.com/patent-ai",
           description: "Ask a preliminary European patent or EU trade mark question and receive an indicative fee estimate for a US company.",
          offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
        }),
      },
    ],
  }),
  component: PatentAiPage,
});

function PatentAiPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <SiteHeader />
      <main className="flex-1">
        <section className="mx-auto max-w-6xl px-6 pb-8 pt-14 md:pt-18">
          <p className="eyebrow mb-4">Ask AI</p>
           <h1 className="max-w-4xl font-serif text-4xl leading-tight text-foreground md:text-5xl">
             European patent and EU trade mark assessment
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-muted-foreground">
             Get a fast orientation on EPO, Euro-PCT and EUIPO procedures, patent drafting, office actions, likely fee items, oppositions, appeals and renewals.
          </p>
        </section>
        <section className="mx-auto max-w-6xl px-6 pb-8">
          <PatentAiChat />
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}